<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new">
      <span slot="left-title">Création d'un Rappel</span>
    </sticky>
    <div class="columns is-gapless has-bg-light is-padding">
      <div class="column is-8 is-8-widescreen is-padding-right">
        <div class="has-bg-white is-radius-large is-border">
          <form @submit.prevent.stop="">
            <div class="columns is-multiline is-margin-top-small">
              <div class="column is-12" v-if="isAdmin || isManager || isOperator">
                <span class="label"></span>
                <input id="reminderForMe" type="checkbox" name="reminderForMe"
                      @click="changeSelfRdv(reminderForMe)"
                      class="switch is-success is-rounded" v-model="reminderForMe">
                <label for="reminderForMe" class="label"><span class="is-size-6 has-text-grey">Ce rappel est pour moi</span></label>
              </div>
              <div class="column is-9" v-if="!reminderForMe">
                <label for="" class="label">Utilisateur *</label>
                <div class="column is-6 is-paddingless-left is-padding-top-xxsmall is-paddingless-bottom is-zindex-2" v-if="!seller">
                  <button class="button is-grey is-outlined is-rounded is-fullwidth is-transform-none"
                          @click.prevent.stop="openSellerSelectionQuickView({type: 'seller'})">
                    <span class="icon"><i class="fas fa-users-crown"></i></span>
                    <span>Sélectionner un utilisateur</span>
                  </button>
                </div>
                <div class="columns is-multiline is-border" v-if="seller">
                  <div class="column is-12">
                    <div class="columns is-gapless">
                      <div class="column is-9 is-vcentered columns">
                        <avatar :item="seller"></avatar>
                        <div class="is-margin-left-small">
                          <div class="title is-4"><b>{{seller.last_name}} {{seller.first_name}}</b></div>
                          <div class="subtitle">{{seller.profil_type|profilTypeLabel}}</div>
                        </div>
                      </div>
                      <div class="column is-3 has-text-right actions">
                        <a class="button is-circle" @click="seller = null"><i class="fal fa-times"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-9">
                <label class="label">Programmer rappel dans :</label>
                <div class="column is-12 columns is-variable is-1 is-multiline is-paddingless">
                  <div class="column is-6 is-paddingless-top is-paddingless-left" style="padding-bottom: var(--columnGap)"
                      v-for="(d, i) in reminderDateList" :key="i">
                  <input :id="d.value" v-model="preselectedDate" :value="d.value" name="typeRdv" @input="selectedDate(d.value)" @click="selectedDate(d.value)"
                          checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
                  <label :for="d.value">{{d.label}}</label>
                </div>
                </div>
              </div>
              <div class="column is-9 is-padding-bottom-xsmall">
                <label class="label">Programmer à une date précise</label>
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-square is-static is-border is-min-width-0">
                      <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded has-icons-right">
                    <flat-pickr v-validate="'required'" @input="checkDate(date)"
                      :class="{'is-danger': errors.has('date')}"
                      :config="configDate" v-model="date" class="input is-radiusless" name="date">
                    </flat-pickr>
                  </div>
                  <div class="control">
                    <a class="button is-square is-radiusless" @click="deleteDate">
                      <i class="fal fa-times"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-9 is-paddingless-bottom">
                <label class="label">Programmer à une heure précise</label>
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-square is-static is-border is-min-width-0">
                      <span class="icon"><i class="fas fa-clock"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded has-icons-right">
                    <flat-pickr @input="checkHour(hour)"
                                :config="configHour" v-model="hour" class="input is-radiusless" name="hour">
                    </flat-pickr>
                  </div>
                  <div class="control">
                    <a class="button is-square is-radiusless" @click="deleteHour">
                      <i class="fal fa-times"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-9 is-padding-bottom-xsmall">
                <v-input :id="'title'" :name="'title'" @input="val => reminder.title = val" :model="reminder.title"
                        label="Nom du rappel *" :errors-bag="errors" data-vv-value-path="val"
                        data-vv-as="Titre" v-validate="'required|min:2'">
                </v-input>
              </div>

              <div class="column columns is-9 is-vcentered">
                <div class="column is-12 is-paddingless">
                  <label for="" class="label">Note (optionnel)</label>
                  <textarea id="note" name="note" class="textarea" v-model="reminder.note"
                          label="Note" data-vv-as="Note" v-validate="'min:2|max:255'">
                  </textarea>
                </div>
              </div>

              <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns">
                <div class="column is-6">
                  <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
                    <span>Annuler</span>
                  </a>
                </div>
                <div class="column is-6">
                  <a class="button is-success is-uppercase is-fullwidth has-text-white" @click="submit"
                          :disabled="!canSubmit || loading" :class="{'is-loading':loading}">
                    <span v-if="!loading">Valider</span>
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'
  import { DefaultValues } from '@/mixins'
  import { isNil, isEmpty, debounce } from 'lodash'

  const emptyReminder = {
    pk: null,
    title: null,
    date: null,
    user: null,
    note: null
  }

  export default {
    name: 'ReminderCreate',
    data () {
      return {
        reminder: {},
        date: null,
        hour: '07:00',
        configDate: {
          minDate: 'today',
          altInput: true,
          altFormat: 'j M Y',
          dateFormat: 'Z'
        },
        configHour: {
          enableTime: true,
          noCalendar: true,
          dateFormat: 'H:i',
          time_24hr: true
        },
        users: [],
        showNotes: false,
        reminderForMe: true,
        loading: false,
        preselectedDate: null,
        seller: null,
        isForMe: true
      }
    },
    mixins: [DefaultValues],
    computed: {
      ...mapState(['currentUserPk', 'quickview']),
      ...mapGetters(['isAdmin', 'isManager', 'isOperator']),
      canSubmit () {
        return this.errors.any() === false && !isNil(this.reminder.title)
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION' && params.type === 'seller') {
            this.seller = results.entities[0]
          }
        }
      }
    },
    methods: {
      deleteDate () {
        this.date = null
        this.preselectedDate = null
      },
      deleteHour () {
        this.hour = null
        let newDate = moment(this.date).set({'hour': 7, 'minute': 0})
        this.date = newDate._d
      },
      checkDate (date) {
        if (date === null || date === '') this.preselectedDate = null
        this.date = date
        let formatDate = moment.utc(date).format('YYYY/MM/DD')
        if (this.preselectedDate !== formatDate) this.preselectedDate = null
      },
      checkHour (hour) {
        this.hour = hour
        let splitHour = hour.split(':')
        let hTime = splitHour[0]
        let mTime = splitHour[1]
        hTime = Number(hTime)
        mTime = Number(mTime)
        let newDate = moment(this.date).set({'hour': hTime, 'minute': mTime})
        this.date = newDate._d
      },
      selectedDate: debounce(function (date) {
        this.date = date
        let splitHour = this.hour.split(':')
        let hTime = splitHour[0]
        let mTime = splitHour[1]
        hTime = Number(hTime)
        mTime = Number(mTime)
        let formatDate = moment(this.date).set({'hour': hTime, 'minute': mTime})
        this.date = formatDate._d
      }, 200),
      submit () {
        if (!this.canSubmit) return
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            if (!this.date && !this.preselectedDate) {
              this.$notify({
                type: 'is-danger',
                text: 'Veuillez sélectionner une date.'
              })
              return
            }
            if (!this.reminderForMe && !(!isEmpty(this.reminder.user) || !isEmpty(this.seller))) {
              this.$notify({
                type: 'is-danger',
                text: 'Veuillez sélectionner un utilisateur.'
              })
              return
            }
            this.loading = true
            if (this.reminderForMe) {
              this.reminder.user = null
            } else {
              this.reminder.user = this.seller.pk
            }
            // this.reminder.date = moment.utc(this.date)
            this.reminder.date = moment(this.date)
            let hour = document.querySelector('.flatpickr-hour').value
            let minute = document.querySelector('.flatpickr-minute').value
            let newDate = moment(this.reminder.date).set({'hour': hour - 2, 'minute': minute})
            this.reminder.date = newDate._d
            this.reminder.date = moment(this.reminder.date).format('DD/MM/YYYY HH:mm')
            this.$api.reminderService.post(this.reminder).then(r => {
              this.loading = false
              this.$router.goBack()
              if (this.reminderForMe) {
                let reminder = r.data
                let key = moment(reminder.date).format('DD/MM/YYYY')
                this.$store.commit('addCalendarEvent', {event: reminder, key, type: 'reminders'})
              }
              this.$notify({
                type: 'is-success',
                text: 'Le rappel a été créé.'
              })
            })
          } else {
            this.loading = false
            this.$notify({
              type: 'is-danger',
              text: 'Erreur Le formulaire est invalide.'
            })
          }
        })
      },
      changeSelfRdv (v) {
        this.isForMe = !this.isForMe
        if (!this.isForMe && !this.loading) {
          this.openSellerSelectionQuickView({type: 'seller'})
        }
      },
      openSellerSelectionQuickView (params) {
        if (isNil(params)) {
          params = {}
        }
        if (!params.excludes) params.excludes = [this.currentUserPk]
        let finalParams = Object.assign({}, params)
        finalParams.facets = {
          'USER': ['is_external:False', 'is_operator:False', 'is_editor:False']
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params: finalParams})
      },
      getUsers (query = null) {
        let filters = {
          first_name: query
        }
        this.$api.userService.get(filters).then(r => {
          this.users = r.data.items
        })
      }
    },
    created () {
      this.getUsers()
      Object.assign(this.reminder, emptyReminder)
      this.date = moment().hours(7).minute(0).second(0).toDate()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reminder/ReminderCreate.vue